const shuffle = list => {
    for (let i = list.length - 1; i > 0; i--) {
        const random = Math.floor(Math.random() * (i + 1));
        const tmp = list[i];
        list[i] = list[random];
        list[random] = tmp;
    }
    return list;
};

const fromHardcoded = ({userID = '0', username}) => {
    const result = {
        image: `https://trampoline.turbowarp.org/avatars/${userID}`,
        text: username
    };
    if (username && userID !== '0') {
        result.href = `https://scratch.mit.edu/users/${username}/`;
    }
    return result;
};

const fromHardcodedPM = ({username}) => {
    const result = {
        image: `https://projects.penguinmod.com/api/v1/users/getpfp?username=${username}`,
        href: `https://studio.penguinmod.com/credits.html#`,
        text: username
    };
    return result;
};

const fromHardcodedGitHub = ({username}) => {
    const result = {
        image: `https://github.com/${username}.png`,
        href: `https://github.com/${username}/`,
        text: username
    };
    return result;
};

// The lists below are in no particular order.

const contributors = [
    {
        userID: '41219524',
        username: 'CubesterYT'
    },
    {
        userID: '64691048',
        username: 'CST1229'
    },
    {
        userID: '128887584',
        username: 'FurryR'
    },
    {
        userID: '17340565',
        username: 'GarboMuffin'
    },
    {
        userID: '12498592',
        username: 'LilyMakesThings'
    },
    {
        userID: '105362329',
        username: 'TrueFantom'
    },
    {
        userID: '9636514',
        username: 'Tacodiva7729'
    },
    {
        userID: '141930175',
        username: 'SimonShiki'
    },
    {
        userID: '34824813',
        username: 'Geotale'
    },
    {
        username: 'Wowfunhappy'
    }
].map(fromHardcoded);

const addonDevelopers = [
    {
        userID: '34018398',
        username: 'Jeffalo'
    },
    {
        userID: '64184234',
        username: 'ErrorGamer2000'
    },
    {
        userID: '41616512',
        username: 'pufferfish101007'
    },
    {
        userID: '61409215',
        username: 'TheColaber'
    },
    {
        userID: '1882674',
        username: 'griffpatch'
    },
    {
        userID: '10817178',
        username: 'apple502j'
    },
    {
        userID: '16947341',
        username: '--Explosion--'
    },
    {
        userID: '14880401',
        username: 'Sheep_maker'
    },
    {
        userID: '9981676',
        username: 'NitroCipher'
    },
    {
        userID: '2561680',
        username: 'lisa_wolfgang'
    },
    {
        userID: '60000111',
        username: 'GDUcrash'
    },
    {
        userID: '4648559',
        username: 'World_Languages'
    },
    {
        userID: '17340565',
        username: 'GarboMuffin'
    },
    {
        userID: '5354974',
        username: 'Chrome_Cat'
    },
    {
        userID: '34455896',
        username: 'summerscar'
    },
    {
        userID: '55742784',
        username: 'RedGuy7'
    },
    {
        userID: '9636514',
        username: 'Tacodiva7729'
    },
    {
        userID: '14792872',
        username: '_nix'
    },
    {
        userID: '30323614',
        username: 'BarelySmooth'
    },
    {
        userID: '64691048',
        username: 'CST1229'
    },
    {
        username: 'DNin01'
    },
    {
        userID: '16426047',
        username: 'Maximouse'
    },
    {
        username: 'retronbv'
    },
    {
        username: 'GrahamSH'
    },
    {
        userID: '22529928',
        username: 'simiagain'
    },
    {
        username: 'Secret-chest'
    },
    {
        userID: '11677378',
        username: 'Mr_MPH'
    },
    {
        username: 'TheKodeToad'
    }
].map(fromHardcoded);

// generated by TurboWarp/extensions/scripts/get-credits-for-gui.js
const extensionDevelopers = [
    {
        username: '-SIPC-'
    },
    {
        username: '0832'
    },
    {
        userID: '17235330',
        username: 'aleb2005'
    },
    {
        userID: '129742989',
        username: 'BludIsAnLemon'
    },
    {
        username: 'BlueDome77'
    },
    {
        username: 'clay-rip'
    },
    {
        userID: '37070511',
        username: 'cs2627883'
    },
    {
        userID: '64691048',
        username: 'CST1229'
    },
    {
        userID: '41219524',
        username: 'CubesterYT'
    },
    {
        userID: '33988895',
        username: 'D-ScratchNinja'
    },
    {
        userID: '20632822',
        username: 'dogeiscut'
    },
    {
        username: 'DT'
    },
    {
        userID: '54392956',
        username: 'Fath11'
    },
    {
        userID: '1882674',
        username: 'griffpatch'
    },
    {
        userID: '41876695',
        username: 'JeremyGamer13'
    },
    {
        userID: '12498592',
        username: 'LilyMakesThings'
    },
    {
        userID: '29571977',
        username: 'man-o-valor'
    },
    {
        username: 'MikeDEV'
    },
    {
        userID: '74246431',
        username: '0znzw'
    },
    {
        userID: '62325737',
        username: 'mybearworld'
    },
    {
        userID: '62950341',
        username: 'NamelessCat'
    },
    {
        username: 'NishiOwO'
    },
    {
        username: 'NOname-awa'
    },
    {
        userID: '26959223',
        username: 'pinksheep2917'
    },
    {
        username: 'Pen-Group'
    },
    {
        username: 'pumpkinhasapatch'
    },
    {
        userID: '126715567',
        username: 'PwLDev'
    },
    {
        userID: '139929771',
        username: 'qxsck'
    },
    {
        userID: '29118689',
        username: 'RedMan13'
    },
    {
        userID: '80038021',
        username: 'RixTheTyrunt'
    },
    {
        userID: '45777723',
        username: 'DemonX5'
    },
    {
        userID: '14880401',
        username: 'Sheep_maker'
    },
    {
        userID: '103496265',
        username: 'shreder95ua'
    },
    {
        userID: '72467731',
        username: 'Skyhigh173'
    },
    {
        userID: '52066199',
        username: 'softed'
    },
    {
        userID: '166646203',
        username: 'Staevski_G'
    },
    {
        username: 'TheShovel'
    },
    {
        userID: '105362329',
        username: 'TrueFantom'
    },
    {
        userID: '19133274',
        username: 'Vadik1'
    },
    {
        username: 'veggiecan0419'
    },
    {
        userID: '82486672',
        username: 'lolecksdeehaha'
    },
    {
        userID: '3318598',
        username: 'plant2014'
    },
    {
        userID: '128778351',
        username: 'XmerOriginals'
    },
    {
        username: 'ZXMushroom63'
    }
].map(fromHardcoded);

const docs = [
    {
        userID: '12498592',
        username: 'LilyMakesThings'
    },
    {
        username: 'DNin01'
    },
    {
        username: 'Samq64'
    },
    {
        username: '61080GBA'
    },
    {
        username: 'adazem009'
    },
    {
        username: 'sajtosteszta32'
    },
    {
        username: 'yoyomonem'
    },
    {
        userID: '55742784',
        username: 'RedGuy7'
    },
    {
        username: '28klotlucas2'
    },
    {
        username: 'PPPDUD'
    },
    {
        username: 'BackThePortal'
    },
    {
        username: 'Naleksuh'
    }
].map(fromHardcoded);

const codeUsedFrom = [
    {
        text: "02 Engine",
        image: `https://gaiamod-main.github.io/icons/mods/02engine.png`,
        href: `https://editor.02engine.org/index.html`,
    },
    {
        text: "AstraEditor",
        image: `https://gaiamod-main.github.io/icons/mods/astraeditor.png`,
        href: `https://editors.astras.top/`,
    },
	    {
        text: "Bilup",
        image: `https://gaiamod-main.github.io/icons/mods/bilup.png`,
        href: `https://com.bilup.org/editor`,
    },
    {
        text: "Adacraft",
        image: `https://gitlab.com/uploads/-/system/group/avatar/8613368/logo.png`,
        href: `https://www.adacraft.org/studio/`,
    },
    {
        text: "MistWarp",
        image: `https://gaiamod-main.github.io/icons/mods/mistwarp.png`,
        href: `https://warp.mistium.com/editor`,
    },
    {
        text: "OmniBlocks",
        image: `https://gaiamod-main.github.io/icons/mods/omniblocks.png`,
        href: `https://omniblocks.github.io/`,
    },
	    {
        text: "LibreKitten",
        image: `https://gaiamod-main.github.io/icons/mods/librekitten.png`,
        href: `https://librekitten.org/`,
    },
	    {
        text: "AmpMod",
        image: `https://gaiamod-main.github.io/icons/mods/ampmod.png`,
        href: `https://ampmod.codeberg.page/`,
    },
	   {
        text: "ScratchBox",
        image: `https://gaiamod-main.github.io/icons/mods/scratchbox.png`,
        href: `https://editor.scratchbox.dev/`,
    },
    {
        text: "Dash",
        image: `https://gaiamod-main.github.io/icons/mods/dashblocks.png`,
        href: `https://dashblocks.org/`,
    },
	    {
        text: "Nitro-Bolt",
        image: `https://gaiamod-main.github.io/icons/mods/nitrobolt.png`,
        href: `https://nitrobolt.org/`,
    },
	{
        text: "CattyMod",
        image: `https://gaiamod-main.github.io/icons/mods/cattymod.png`,
        href: `https://cattymod.app/`,
    },
    {
        text: "Cocrea World",
        image: `https://gaiamod-main.github.io/icons/mods/cocreaworld.png`,
        href: `https://www.cocrea.world/`,
    },
	{
        text: "GaiaMod",
        image: `https://gaiamod-main.github.io/icons/mods/gaiamod.png`,
        href: `https://gaiamod-main.github.io/`,
    },
    {
        text: "ElectraMod",
        image: `https://gaiamod-main.github.io/icons/mods/electramod.png`,
        href: `https://electramod.vercel.app/`,
    },
    {
        text: "Snail IDE",
        image: `https://gaiamod-main.github.io/icons/mods/snailide.png`,
        href: `http://snail-ide.js.org/`,
    },
	 {
        text: "Ark IDE",
        image: `https://gaiamod-main.github.io/icons/mods/arkide.png`,
        href: `https://studio.arkide.site/`,
    },
	{
        text: "Nyx IDE",
        image: `https://gaiamod-main.github.io/icons/mods/nyxide.png`,
        href: `https://ide.nyxdev.app/editor`,
    },
    {
        text: "DinosaurMod",
        image: `https://gaiamod-main.github.io/icons/mods/dinosaurmod.png`,
        href: `https://dinosaurmod.github.io/`,
    },
	 {
        text: "PenguinMod",
        image: `https://gaiamod-main.github.io/icons/mods/penguinmod.png`,
        href: `https://studio.penguinmod.com/`,
    },	
    {
        text: "TurboWarp",
        image: `https://gaiamod-main.github.io/icons/mods/turbowarp.png`,
        href: `https://turbowarp.org/`,
    },
    {
        text: "scratchfoundation",
        image: `https://gaiamod-main.github.io/icons/mods/scratch.png`,
        href: `https://scratch.mit.edu/`,
    },
];

export default {
    contributors: shuffle(contributors),
    addonDevelopers: shuffle(addonDevelopers),
    extensionDevelopers: shuffle(extensionDevelopers),
    docs: shuffle(docs),
    codeUsedFrom: shuffle(codeUsedFrom)
};
